import { ButtonGroup, ListItem, ListItemText } from '@mui/material';
import { Button } from 'reactstrap';
import React from 'react';
import copy from 'copy-to-clipboard';
import { ThemeProvider } from '@mui/material/styles';
import Tooltip from '@katalon-studio/katalon-ui/Tooltip';
import DropDownMenu from '../../components/navigationbar/DropDownMenu';
import { IconDropDown, IconDropDownLight } from '../../images/CustomIcon';
import Notification from '../../utils/Notification';
import { t } from '../../i18n/t';
import GroupEvent from '../../utils/track/GroupEvent';
import { katalonui_theme } from '../../katalonui-theme';

function RunPlanDropdownButton({ name, onClick, apiSupport, dataTrackId, dataGroupId, disabled, disableTooltip, ...props }) {

  const dropDownRef = React.useRef(null);

  const handleGetAPIRunPlan = () => {
    copy(apiSupport);
    Notification.pushSuccess('Request params has copied.');
  };

  const toggleDropdown = () => {
    dropDownRef.current.toggle();
  };

  const selectReleaseButton = (props) => (
    <Button className="drop-down" {...props}>
      <div className="icon-inactive">
        <IconDropDown />
      </div>
      <div className="icon-active">
        <IconDropDownLight />
      </div>
    </Button>
  );

  return (
    <ButtonGroup {...props} className="group-btn">
      <ThemeProvider theme={katalonui_theme}>
        <Tooltip
          className="ml-2"
          label={disableTooltip}
          size="medium"
          placement="bottom"
          disableHoverListener={!disabled}
        >
          <div>
            <Button
              onClick={() => onClick()}
              data-trackid={dataTrackId}
              data-groupid={dataGroupId}
              disabled={disabled}
            >
              {name}
            </Button>
          </div>
        </Tooltip>
      </ThemeProvider>
      <DropDownMenu
        renderAnchorElement={selectReleaseButton}
        expandDirection="right"
        ref={dropDownRef}
      >
        <ListItem
          button
          data-trackid="copy-run-plan-rest-api"
          data-groupid={GroupEvent.ACCESS_REPORT}
          onClick={() => {
            handleGetAPIRunPlan();
            toggleDropdown();
          }}
        >
          <ListItemText>
            {t('copyRequestParams')}
          </ListItemText>
        </ListItem>
      </DropDownMenu>
    </ButtonGroup>
  );
}

export default RunPlanDropdownButton;
